import { View } from "react-native";
import React from "react";
import { sn } from "utils";
import css from "styles";
import { colors, sizes } from "assets/constants";
import { Icon, Img, ImgIcon, Shadow, Text } from "components";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import tinycolor from "tinycolor2";
import { icons } from "assets/icons";

export default function UserInfoCard() {
  const user = useRecoilValue(authAtom);
  return (
    <Shadow
      style={{
        flex: 1,
        padding: sizes.space,
        height: sn(140, 140, 150, 150),
        backgroundColor: colors.white,
        borderRadius: sizes.radius.xl,
      }}
    >
      <View style={{ marginRight: sizes.space, height: 40 }}>
        <Text
          weight="extraBold"
          color={tinycolor(colors.organization).lighten(25).toString()}
          size={"lg"}
        >
          اطلاعات کاربر :
        </Text>
      </View>
      <View
        style={{
          flex: 1,
          alignItems: "center",
          flexDirection: "row-reverse",
        }}
      >
        <View
          style={{
            height: "100%",
            maxHeight: 150,
            aspectRatio: 1,
            borderRadius: 100,
            overflow: "hidden",
            borderWidth: 3,
            borderColor: colors.white,
            backgroundColor: colors.progressBarInactive,
            ...css.shadow(5),
          }}
        >
          <Img
            source={{ uri: user?.avatar }}
            style={{ width: "100%", height: "100%" }}
            resizeMode="contain"
          />
        </View>
        <View style={{ marginRight: sizes.space }}>
          <Text
            size={"lg"}
            weight="extraBold"
            color={tinycolor(colors.organization).darken(1).toString()}
          >
            {user?.name}
          </Text>
          <View
            style={{
              flexDirection: "row-reverse",
              alignItems: "center",
              marginVertical: 5,
            }}
          >
            <ImgIcon
              size={15}
              icon={icons._smartphone}
              color={tinycolor(colors.organization).lighten(10).toString()}
            />
            <View style={{ marginRight: sizes.space / 2 }}>
              <Text
                style={{ letterSpacing: 1.2 }}
                color={colors.text.gray}
                weight="black"
              >
                {user?.mobile}
              </Text>
            </View>
          </View>
          <View style={{ flexDirection: "row-reverse", alignItems: "center" }}>
            <ImgIcon
              size={15}
              icon={icons._role}
              color={tinycolor(colors.organization).lighten(10).toString()}
            />
            <View style={{ marginRight: sizes.space / 2 }}>
              <Text size={"sm"} weight="bold">
                {user?.role} {user?.company?.name}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Shadow>
  );
}
